import { useGetMemberFee } from "./useGetMemberFee";
import { useGetMemberCount } from "./useGetMemberCount";
import * as React from "react";
import { useAtom } from "jotai";
import { CustomIncomeAtom, ExpensesAtom } from "./atoms";

export function useGetProfit() {
  const getMemberFee = useGetMemberFee();
  const getMemberCount = useGetMemberCount();
  const [initialIncome] = useAtom(CustomIncomeAtom);
  return React.useCallback(
    x => {
      let memberCount = getMemberCount(x);
      let memberFee = getMemberFee(x);

      return memberCount * memberFee + initialIncome;
    },
    [getMemberCount, getMemberFee, initialIncome]
  );
}
